import script from "./basicForm.vue?vue&type=script&setup=true&lang=js"
export * from "./basicForm.vue?vue&type=script&setup=true&lang=js"

import "./basicForm.vue?vue&type=style&index=0&id=d1a76d52&scoped=true&lang=css"
import "./basicForm.vue?vue&type=style&index=1&id=d1a76d52&lang=css"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1a76d52"]])

export default __exports__